/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateUnitAppDataRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateUnitAppDataResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateUnitAppData = (request: UpdateUnitAppDataRequest, options?: CashRequestOptions) => post<UpdateUnitAppDataRequest, UpdateUnitAppDataResponse>("/2.0/cash/update-unit-app-data", request, {...options, rejectOnError: true })